module.exports = __webpack_public_path__ + "media/images/icon-filter-time-2ad060afeee339f5ea996e2259386e73.png";